import React from "react";
import { Box, Text, Button, Layer } from "grommet";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import { useState, useEffect } from "react";
import { Spinner } from "grommet";
import { Card, CardBody, CardFooter } from "grommet";
import { Grid } from "grommet";
import { Heading } from "grommet";
import { getCourses } from "../../services/getCourses";
export const LearningPathModal = ({
    user_id,
    assessment_id,
    skills_id,
    onClose,
}) => {
    const navigate = useNavigate();
    const [recommendedPaths, setRecommendedPaths] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showAllProducts, setShowAllProducts] = useState(true);
    // const { user_id, assessment_id } = useParams();
    const [popup, setPopup] = useState({
        message: "",
        status: "",
        visible: false,
    });
    const fetchCourseData = async () => {
        try {
            const response = await getCourses({ user_id, assessment_id });
            const filteredCourses = response.data.courses.filter(
                (course) => course.skills_id === skills_id, // Filter by selected skills_id
            );
            setRecommendedPaths(filteredCourses);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching recommended paths:", error);
        }
    };
    useEffect(() => {
        fetchCourseData();
    }, []);
    const handleEnroll = (course) => {
        if (course.c_id === "H45ZDS") {
            window.open(
                `https://www.hpe.com/us/en/collaterals/collateral.a50013061enw.html`,
                "_blank",
            );
        } else if (course.c_id === "H45ZCS") {
            window.open(
                `https://www.hpe.com/us/en/collaterals/collateral.a50013273enw.html`,
                "_blank",
            );
        } else if (course.OEM === "morpheus") {
            window.open(
                `https://education.hpe.com/ww/en/training/contactus.html`,
                "_blank",
            );
        } else {
            window.open(
                `https://education.hpe.com/ww/en/training/docs/cds/${course.c_id}.pdf`,
                "_blank",
            );
        }
    };
    // const toggleAllCoursesVisibility = () => {
    //   setShowAllProducts((prevState) => !prevState);
    // };

    const handleelearningEnroll = (course) => {
        const course_code_map = {
            "HPE OneView for Compute": "H62E2AAE",
            "HPE OneView for HPE ProLiant DL/ML Servers": "H9TR9AAE",
            "HPE Synergy Administration with HPE OneView": "H0LP7AAE",
            "HPE SimpliVity System Administration": "H9TS2AAE",
        };
        const modifiedCourseId = course_code_map[course.name];

        window.open(
            `https://education.hpe.com/ww/en/training/docs/cds/${modifiedCourseId}.pdf`,
            "_blank",
        );
    };
    const displayedCourses = showAllProducts
        ? recommendedPaths
        : recommendedPaths;
    const handleViewCourses = (course) => {
        // include user_id, assessment_id AND the learningpath_id in the URL
        navigate(
            `/learning-path/${user_id}/${assessment_id}/${course.learningpath_id}`
        );
    };

    return (
        <Layer
            onEsc={onClose}
            onClickOutside={onClose}
            position="center"
            modal
            alignSelf="center"
            alignContent="center"
            style={{ maxHeight: "80vh", overflow: "auto" }}
        >
            <Box pad="medium">
                <Box pad="small" align="center" margin={{ bottom: "medium" }}>
                    {isLoading ? (
                        <Box align="center" pad="medium">
                            <Spinner size="medium" />
                            <Text>Loading recommended courses...</Text>
                        </Box>
                    ) : recommendedPaths.length > 0 ? (
                        <>
                            <Box pad="small" margin="medium">
                                <Grid
                                    columns={{ count: 3, size: "auto" }} // Ensure 3 cards per row
                                    gap="medium" // Adjust gap between cards to make them look less congested
                                    pad={{ horizontal: "small", vertical: "small" }}
                                >
                                    {displayedCourses.map((course) => (
                                        <Card
                                            key={course.id}
                                            background="light-1"
                                            pad="small"
                                            margin="small"
                                            elevation="small"
                                            round="small"
                                            style={{
                                                border: "1px solid #E0E0E0",
                                                minWidth: "300px",
                                                maxWidth: "350px",
                                                minHeight: "250px",
                                            }}
                                        >
                                            <CardBody pad="small">
                                                <Box fill="vertical" justify="between" gap="small">
                                                    <Heading
                                                        level="3"
                                                        margin={{ top: "none", bottom: "small" }}
                                                        style={{ minHeight: "40px", color: "#333" }}
                                                    >
                                                        {course.name}
                                                    </Heading>
                                                    <Box gap="xsmall">
                                                        <Text size="small" color="dark-4">
                                                            Duration: <strong>{course.duration}</strong>
                                                        </Text>
                                                        <Text size="small" color="dark-4">
                                                            {course.isElearning === 2
                                                                ? "eLearning/ILT/VILT"
                                                                : course.isElearning
                                                                    ? "eLearning"
                                                                    : "ILT/VILT"}
                                                        </Text>
                                                    </Box>
                                                </Box>
                                            </CardBody>

                                            <CardFooter
                                                pad={{ horizontal: "small", vertical: "small" }}
                                                background="light-2"
                                                round={{ corner: "bottom", size: "small" }}
                                                style={{ borderTop: "1px solid #E0E0E0" }}
                                                direction="column"
                                            >
                                                {/* First Row: Course Outline and eLearning Outline */}
                                                <Box
                                                    direction="row"
                                                    gap="small"
                                                    fill="horizontal"
                                                    justify="center"
                                                >
                                                    {course.c_id === "H45ZMAAE" || course.c_id === "H45YZS" || course.c_id === "H45YYS" ? (
                                                        <Button
                                                            label="Contact us to enroll"
                                                            onClick={() => handleEnroll(course)}
                                                            primary
                                                            size="small"
                                                            style={{ minWidth: "120px" }}
                                                        />
                                                    ) : (
                                                        <Button
                                                            label="View course data sheet"
                                                            onClick={() => handleEnroll(course)}
                                                            primary
                                                            size="small"
                                                            style={{ minWidth: "120px" }}
                                                        />
                                                    )}
                                                    {course.isElearning === 2 && (
                                                        <Button
                                                            label="View eLearning data sheet"
                                                            onClick={() => handleelearningEnroll(course)}
                                                            secondary
                                                            size="small"
                                                            style={{ minWidth: "120px" }}
                                                        />
                                                    )}
                                                </Box>

                                                {/* Second Row: Learning Path */}
                                                <Box fill="horizontal" justify="center">
                                                    <Button
                                                        label="View learning path"
                                                        onClick={() => handleViewCourses(course)}
                                                        secondary
                                                        size="small"
                                                        style={{ minWidth: "120px" }}
                                                    />
                                                </Box>
                                            </CardFooter>
                                        </Card>
                                    ))}
                                </Grid>
                            </Box>

                            {/* {recommendedPaths.length > 3 ? (
                <Box
                  align="center"
                  margin={{ top: "medium" }}
                  alignSelf="center"
                  alignContent="center"
                >
                  <Button
                    color="brand"
                    label={
                      showAllProducts
                        ? "Show less courses"
                        : "Show more courses"
                    }
                    onClick={toggleAllCoursesVisibility}
                  />
                </Box>
              ) : null} */}

                            {popup.visible && (
                                <Layer
                                    onEsc={() => setPopup({ ...popup, visible: false })}
                                    onClickOutside={() => setPopup({ ...popup, visible: false })}
                                >
                                    <Box pad="medium" gap="small" width="medium">
                                        <Heading level={3} margin="none">
                                            {popup.status === "normal" ? "Success" : "Error"}
                                        </Heading>
                                        <Text>{popup.message}</Text>
                                        <Box direction="row" gap="medium" justify="end">
                                            <Button
                                                label="Close"
                                                onClick={() => setPopup({ ...popup, visible: false })}
                                                primary
                                            />
                                        </Box>
                                    </Box>
                                </Layer>
                            )}
                        </>
                    ) : (
                        <Text margin={{ top: "small", left: "small" }}>
                            Based on the skills that you have selected and your responses,
                            there are currently no recommended courses. You can try a new
                            self-assessment with a new set of skills.
                            <br />
                            We recommend <b>HPE Digital Learner</b> to keep your skills
                            refreshed and learn further skills 24/7x365 days.
                        </Text>
                    )}
                </Box>
            </Box>
        </Layer>
    );
};
